<template>
    <form-container :title="stageTitle">

      <form-yes-no-radio-list class="mt-4"
          id="isPolicyholder" 
          v-model="claimantObj.policyholder" 
          label="Please confirm that you are the policyholder."
          validationFieldLabel="isPolicyholder"
          validationInvalidFeedback="Please indicate whether the device was in the possesion of the policyholder when the incident happened">
        </form-yes-no-radio-list>

      <form-title-select
          id="claimantTitle" 
          v-model="claimantObj.title" 
          label="Title"
          validationFieldLabel="claimantTitle"
          validationInvalidFeedback="Please select your title">
      </form-title-select>

        <label for="claimantFirstname">First name</label>
        <input type="text" 
               id="claimantFirstname" 
               fieldlabel="claimant Firstname" 
               v-model="claimantObj.firstname" 
               v-taurus-validator="'required'" 
               class="form-control form-control-lg">
        <div name="claimantFirstname" invalidfeedback="Please provide their first name"></div>

        <label for="claimantLastname">Last name</label>
        <input type="text" 
               id="claimantLastname" 
               fieldlabel="claimant Lastname" 
               v-model="claimantObj.lastname" 
               v-taurus-validator="'required'"
               class="form-control form-control-lg">
        <div name="claimantLastname" invalidfeedback="Please provide their last name"></div>

        
        <label for="">Date of birth</label>
        <input type="text" 
                id="dob"                  
                fieldlabel="Date of birth" 
                placeholder="DD/MM/YYYY" 
                v-model="claimantObj.dateOfBirth" 
                v-taurus-validator="'date_format:DD/MM/YYYY|required'" 
                class="form-control form-control-lg">
        <div class="" name="dob" invalidfeedback="Please enter your date of birth in the following format DD/MM/YYYY"></div>
        

        <label for="claimantEmail">Email</label>
        <input type="text" 
               id="claimantEmail" 
               class="form-control form-control-lg"
               fieldlabel="claimant Email" 
               v-model="claimantObj.email" 
               v-taurus-validator="'required|is_email'">
        <div name="claimantEmail" invalidfeedback="Please enter a valid email address"></div>

        <label for="confirmEmail">Confirm Email</label>
        <input type="text" 
               id="confirmEmail" 
               class="form-control form-control-lg"
               fieldlabel="confirm Email" 
               v-taurus-validator="'same_as:claimantObj.email'"
               v-model="claimantObj.confirmEmailAddress" >
        <div name="confirmEmail" invalidfeedback="Email and Confirm Email must match"></div>

        <!-- <label for="claimantTel">Mobile</label>
        <input type="text" 
               id="claimantTel" 
               fieldlabel="claimant Telephone" 
               class="form-control form-control-lg"
               v-model="claimantObj.mobile" 
               v-taurus-validator="'required'">
        <div name="claimantTel" invalidfeedback="Please enter a telephone number"></div> -->

        <form-telephone-input 
              v-model="claimantObj.mobile" 
              id="claimantTel" 
              validationFieldLabel="claimantTel"
              label="Mobile"
              validationRules="required"
              validationInvalidFeedback="Please enter a telephone number"></form-telephone-input>

        <form-telephone-input
              v-model="claimantObj.alternateTelephone" 
              id="altTel" 
              validationFieldLabel="claimantTel"
              label="Alternate Telephone (If you are claiming for a mobile phone)"
              validationInvalidFeedback="Please enter a telephone number"></form-telephone-input>

        <!-- <label for="altTel">Alternate Telephone (If you are claiming for a mobile phone)</label>
        <input type="text" 
               id="altTel" 
               fieldlabel="claimant Telephone" 
               class="form-control form-control-lg"
               v-model="claimantObj.alternateTelephone">
        <div name="altTel" invalidfeedback="Please enter their telephone number"></div> -->

        <div class="form-group">
          <label for="claimantAddressLine1">Address</label>
          <input type="text" 
                id="claimantAddressLine1" 
                fieldlabel="claimant Address line 1"
                class="form-control form-control-lg" 
                v-model="claimantObj.address.line1" 
                v-taurus-validator="'required'">
          <div name="claimantAddressLine1" invalidfeedback="Please enter the first line of your address"></div>
          <input type="text" 
                 id="claimantAddressLine2" 
                 fieldlabel="claimant Address line 2"
                 class="form-control form-control-lg"
                 v-model="claimantObj.address.line2">
          <div name="claimantAddressLine2"></div>
          <label for="claimantAddressCity">Town / City</label>
          <input type="text" 
                 id="claimantAddressCity" 
                 fieldlabel="claimant Address City" 
                 class="form-control form-control-lg"
                 v-model="claimantObj.address.city"
                 v-taurus-validator="'required'">
          <div name="claimantAddressCity" invalidfeedback="Please enter the town / city of your address"></div>
          <label for="claimantAddressCounty">County</label>
          <input type="text" 
                 id="claimantAddressCounty" 
                 fieldlabel="claimant Address County"
                 class="form-control form-control-lg" 
                 v-model="claimantObj.address.county"
                 v-taurus-validator="'required'">
          <div name="claimantAddressCounty" invalidfeedback="Please enter the county of your address"></div>
          <label for="claimantAddressPostcode">Postcode</label>
          <input type="text" 
                 id="claimantAddressPostcode" 
                 fieldlabel="claimant Address Postcode"
                 class="form-control form-control-lg" 
                 v-model="claimantObj.address.postcode"
                 v-taurus-validator="'required'">
          <div name="claimantAddressPostcode" invalidfeedback="Please enter the postcode of your address"></div>
        </div>
        <transition name="fade">
        <div v-if="claimantObj.policyholder && claimantObj.policyholder == true" class="form-group bumper" style="margin-top: 8">
          
          <form-yes-no-radio-list
          id="detailsDiffer" 
          v-model="claimantObj.detailsDiffer" 
          label="Are any of the above different to your policy details?"
          validationFieldLabel="detailsDiffer"
          validationInvalidFeedback="Please indicate whether the above details are different to those on your policy schedule"></form-yes-no-radio-list>
          
        </div>
        </transition>

        <form-button-bar
            :back_button_show='false'
            :next_button_enable='true'
            :next_button_show='true'
            :next_button_icon_enable='true'
            
            :next_button_action='handleNextClick' />

        <loading :active.sync="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
    </form-container>
</template>

<script>

import tigaClaimForm from '@/mixins/tigaClaimForm'
import FormContainer from '@/components/FormContainer.vue'
import FormYesNoRadioList from '@/components/FormYesNoRadioList.vue'
import FormTitleSelect from '@/components/FormTitleSelect.vue'
import FormTelephoneInput from "@/components/FormTelephoneInput.vue";
import FormButtonBar from '@/components/standaloneForm/FormButtonBar.vue'

import loading from 'vue-loading-overlay'

let claimantEmpty = {
  title: null,
  firstname: null,
  lastname: null,
  telephone: null,
  mobile: null,
  alternateTelephone: null,
  email: null,
  confirmEmail: null,
  address: {
    line1: null,
    line2: null,
    city: null,
    county: null,
    postcode: null
  },
  dateOfBirth: '',
  detailsDiffer: null,
  policyholder: null
}

export default {
  name: 'policyDetails',
  components: {
    loading,
    FormContainer,
    FormYesNoRadioList,
    FormTitleSelect,
    FormTelephoneInput,
    FormButtonBar
  },
  mixins: [
    tigaClaimForm   
  ],
  data () {
    return {      
      claimantObj: Object.assign({}, claimantEmpty),
      policyholder: {
        title: '',
        firstname: '',
        lastname: '',
        mobileNumber: '',
        telephoneNumber: '',
        email: '',
        address: {
          line1: '',
          line2: '',
          city: '',
          county: '',
          postcode: ''
        },
        dateOfBirth: '',
        policyholder: null
      }
    }
  },
  beforeCreate() {
    this.$thisIsAForm = true
  },
  mounted () {
    if (!this.claimformHasPolicyNumber) {
      this.gotoStage1();
    }
    this.policyholder = { ...this.standalonePolicy.policyholder }
  },
  watch: {
    'claimantObj.policyholder' (newVal) {
      if (newVal == true) {
        if (this.policyholder) {
          if (this.policyholder.title && this.policyholder.title != '') {
            this.claimantObj.title = this.policyholder.title
          }
          this.claimantObj.firstname = this.policyholder.firstname
          this.claimantObj.lastname = this.policyholder.lastname
          this.claimantObj.mobile = this.policyholder.telephoneNumber
          this.claimantObj.email = this.policyholder.emailAddress
          this.claimantObj.dateOfBirth = this.policyholder.dateOfBirth
          this.claimantObj.address = Object.assign({}, this.policyholder.address)
          this.claimantObj.detailsDiffer = null
        }
      } else {
        this.claimantObj.detailsDiffer = true
      }
    }
  },
  computed: {
    stageTitle() {
      return this.$textManager.getText("title", this.$route.name)
    }
  },
  methods: {
    handleNextClick () {      
      if (this.checkForm()) {
        if (this.policyholder.emailAddress != null && this.policyholder.emailAddress != '') {
          this.setClaimantCheckForUser(this.claimantObj)
        } else {
          this.setClaimant(this.claimantObj)
        }
        this.$router.push({ path: '5' })
      }
    },
    
  }
}
</script>
